const environment = {
    production: true,
    publicMode: true, // set to true for public version (no auth required)
    basename: '/etic', //Set to / for localhost, /etic for public and /inside/etic for inside
    insideApiUrl: 'https://npgallery.nps.gov/inside/api/',
    npgApiUrl: 'https://npgallery.nps.gov/api/',
    apiUrl: 'https://npgallery.nps.gov/ETIC/api/',
    eticApiUrl: 'https://npgallery.nps.gov/api/ETIC/',
    microUrl: 'https://npgallery.nps.gov/etic/api/',
    apiCommonsUrl: 'https://central.nps.gov/units/api/v1/',
    npgAPI: 'https://npgallery.nps.gov/api/',
    webUrl: 'https://npgallery.nps.gov/inside/etic/',
    statisticsAPI: 'https://npgallery.nps.gov/api/eticstatistics/',
   // webUrl: 'http://localhost:3000/', //
    logIntercepter: false,
    pageSize: 10,
    serviceResultSize: 50,
    servicePageNumber: 1,
    pageSizeOptions:[5,10,25,50,100],
    idleTime: 1800,
    timeOutCountdown: 60,
    idleSensitivity:1,
    trackUserInactivity:true,
    clientId: 'client_etic_ui_local',
};

export default environment;